// AppProfile/QuestionTemplate.js

import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import TemplateListGroup from "../../../components/bootstrap/TemplateListGroup";
import HistoryPredictionsView from "../../../components/bootstrap/HistoryPredictionsView";
import HistoryGoalsView from "../../../components/bootstrap/HistoryGoalsView";
import HistoryBucketlistView from "../../../components/bootstrap/HistoryBucketlistView";
import GroupListAdmin from "../../../components/bootstrap/PredictionsListGroupAdmin";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";

const norm = (s) => (s || "").toLowerCase().replace(/\s+/g, " ").trim();

const escapeAttr = (value) =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

const getMaxRows = (category) => {
  const raw =
    category === "Predictions"
      ? process.env.REACT_APP_MAX_PREDICTIONS
      : process.env.REACT_APP_MAX_QUESTIONS;

  const n = Number.parseInt(raw || "50", 10);
  return Number.isFinite(n) && n > 0 ? n : 50;
};

const serializeInputsExtras = (nodeList, serverNorms) =>
  [...nodeList]
    .filter((inp) => {
      const txt = norm(inp.value || "");
      if (!txt) return false;
      if (!inp.name) return true;
      return !serverNorms.has(txt);
    })
    .map((inp) => ({ text: (inp.value || "").trim() }));

const buildInputsHtml = (questionsArr) => {
  const items = Array.isArray(questionsArr) ? questionsArr : [];
  return items
    .map((q) => {
      const valueid = q?.taskid || uuidv4();
      const value = escapeAttr(q?.text || "");
      return `<input type="text" class="swal2-input" id="${valueid}" name="${valueid}" maxlength="150" style="width: 100%; font-size: 12px;" value="${value}">`;
    })
    .join("");
};

const QuestionsTemplate = ({
  userAdminGroups,
  userIsGroupAdmin,
  userGroups,
  type,
}) => {
  const [allGroups, setAllGroups] = useState([]);
  const [selectedGroupId, setSelectedGroupId] = useState("0");
  const handleGroupSelect = (groupId) => setSelectedGroupId(groupId);

  const [storedRoleEnhanced, setStoredRoleEnhanced] = useState("?");
  const currentDate = new Date();
  const currentYearVal = currentDate.getFullYear();

  const [currentYear, setCurrentYear] = useState(currentYearVal);
  const [pastYear, setPastYear] = useState(currentYearVal - 1);
  const [nextYear, setNextYear] = useState(currentYearVal + 1);

  const [predictionsYear, setPredictionsYear] = useState(
    new Date().getFullYear()
  );
  const [goalsYear, setGoalsYear] = useState(new Date().getFullYear());
  const [bucketlistYear, setBucketlistYear] = useState(
    new Date().getFullYear()
  );

  const storedUser = localStorage.getItem("userDetails");
  const storedDetails = JSON.parse(storedUser || "{}");
  const storedRole = storedDetails?.data?.role;
  const storedUserId = storedDetails?.data?.id;

  const [predictionsByYear, setPredictionsByYear] = useState({});
  const [currentPredictions, setCurrentPredictions] = useState({
    predictions: [],
  });
  const [pastPredictions, setPastPredictions] = useState({ predictions: [] });
  const [nextPredictions, setNextPredictions] = useState({ predictions: [] });

  const [goalsByYear, setGoalsByYear] = useState({});
  const [currentGoals, setCurrentGoals] = useState({ predictions: [] });
  const [pastGoals, setPastGoals] = useState({ predictions: [] });
  const [nextGoals, setNextGoals] = useState({ predictions: [] });

  const [templatePredictionsMap, setTemplatePredictionsMap] = useState();
  const [templateGoalsMap, setTemplateGoalsMap] = useState();

  const [templateBucketlistMap, setTemplateBucketlistMap] = useState();
  const [bucketlistByYear, setBucketlistByYear] = useState({});
  const [currentBucketlist, setCurrentBucketlist] = useState({
    predictions: [],
  });
  const [pastBucketlist, setPastBucketlist] = useState({ predictions: [] });
  const [availablePredictionYears, setAvailablePredictionYears] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const tokenDetailsString = localStorage.getItem("userDetails");
  const tokenDetails = JSON.parse(tokenDetailsString || "{}");
  const token = tokenDetails?.token;

  const isTemplateReady = (category, year) => {
    const y = Number(year);
    if (category === "Predictions") {
      const list = predictionsByYear?.[y]?.[0]?.questions || [];
      return list.length > 0;
    }
    return false;
  };

  const fetchRoleData = async () => {
    try {
      const chkrUserRole = await axios.get(
        `${process.env.REACT_APP_PREDICTIONS_API}/api/getUserGroupsAdmin/${storedUserId}`
      );
      const userGroupsInfo = chkrUserRole?.data?.data?.userGroups || [];
      const hasGroupAdminRole = userGroupsInfo.some(
        (group) => group.role === "groupAdmin"
      );

      if (hasGroupAdminRole) setStoredRoleEnhanced("groupAdmin");
      else setStoredRoleEnhanced(storedRole);
    } catch (error) {
      console.error("Error fetching data:", error);
      setStoredRoleEnhanced(storedRole);
    }
  };

  useEffect(() => {
    fetchRoleData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      let groupName = localStorage.getItem("user_initial_Group");

      //Goals
      // const mapGoal = await fetch(
      //   `${process.env.REACT_APP_PREDICTIONS_API}/api/template-goals/${groupName}`,
      //   {
      //     method: "GET",
      //     headers: {
      //       "Content-Type": "application/json",
      //       Authorization: `Bearer ${token}`,
      //     },
      //   }
      // );

      // const templateGoalsMap = await mapGoal.json();

      // console.log(templateGoalsMap);

      // templateGoalsMap.forEach((goal) => {
      //   const year = goal.year;
      //   goalsByYear[year] = [];

      //   goalsByYear[year].push(goal);
      // });

      // Object.keys(goalsByYear).forEach((year) => {
      //   const predictions = goalsByYear[year][0].questions.map((question) => {
      //     setGoalsYear(goalsYear === 1970 ? year : goalsYear);
      //     const prediction = {
      //       questionId: question._id,
      //       // Add more fields as needed
      //     };

      //     if (question.taskid && question.text) {
      //       prediction.taskId = question.taskid;
      //       prediction.text = question.text;
      //     }

      //     return prediction;
      //   });

      //   if (parseInt(year, 10) === pastYear) {
      //     setPastGoals({ predictions });
      //   }
      //   if (parseInt(year, 10) === currentYear) {
      //     setCurrentGoals({ predictions });
      //   }
      //   if (parseInt(year, 10) === nextYear) {
      //     setNextGoals({ predictions });
      //   }
      // });

      try {
        const mapPrediction = await fetch(
          `${process.env.REACT_APP_PREDICTIONS_API}/api/template-predictions`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const templatePredictionsMap = await mapPrediction.json();

        const byYear = {};
        templatePredictionsMap.forEach((pred) => {
          const year = Number(pred.year);
          if (!isNaN(year)) {
            if (!byYear[year]) byYear[year] = [];
            const template = {
              ...pred,
              questions: Array.isArray(pred.questions) ? pred.questions : [],
            };
            byYear[year].push(template);
          }
        });

        const years = Object.keys(byYear)
          .map((y) => Number(y))
          .filter((y) => !isNaN(y))
          .sort((a, b) => a - b);

        setPredictionsByYear(byYear);
        setAvailablePredictionYears(years);
        setIsLoading(false);
      } catch (e) {
        console.error("Template fetch error:", e);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {}, [predictionsByYear, goalsByYear, bucketlistByYear]);

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .sw-responsive { max-width: 80%; }
      @media (max-width: 576px) { .sw-responsive { max-width: 95%; } }
      .swal2-html-container { max-width: 100%; }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const handleButtonClick = async (category, questions, useYear) => {
    let displayYear =
      category === "Predictions"
        ? useYear
        : category === "Goals"
        ? useYear
        : category === "Bucketlist"
        ? "?"
        : "-";

    let groupQuestions = [];
    let groupQuestionList = [];

    const isGroupAdmin =
      storedRole === "groupAdmin" || storedRoleEnhanced === "groupAdmin";

    if (isGroupAdmin) {
      const memberId = storedDetails?.data?.id;
      const encodedMemberId = encodeURIComponent(memberId || "");
      const currentGroupName = localStorage.getItem("user_initial_Group");
      const encodedGroupName = currentGroupName
        ? encodeURIComponent(currentGroupName)
        : "";

      if (category === "Predictions") {
        const url = `${
          process.env.REACT_APP_PREDICTIONS_API
        }/api/get-yealy-predictions/${displayYear}/${encodedMemberId}${
          encodedGroupName ? `?groupName=${encodedGroupName}` : ""
        }`;

        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          groupQuestions = await response.json();
          groupQuestionList = groupQuestions?.groups?.[0] || null;
        } else {
          console.error(
            "Failed to fetch predictions. Status:",
            response.status
          );
          groupQuestionList = null;
        }
      }
    }

    const serverArr = (groupQuestionList?.predictions?.[0]?.questions || [])
      .map((q) => (q?.text || "").trim())
      .filter(Boolean);

    const serverNorms = new Set(serverArr.map(norm));

    // Load draft extras from server
    let localItems = [];
    if (isGroupAdmin) {
      const currentGroupName = localStorage.getItem("user_initial_Group");
      if (currentGroupName) {
        try {
          const encodedGroupName = encodeURIComponent(currentGroupName);
          const yearForLS = category === "Goals" ? useYear : displayYear;

          const draftResponse = await fetch(
            `${process.env.REACT_APP_PREDICTIONS_API}/api/get-draft-questions/${category}/${yearForLS}/${encodedGroupName}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (draftResponse.ok) {
            const draftData = await draftResponse.json();
            localItems = (draftData?.questions || [])
              .map((it) => ({ text: (it?.text || "").trim() }))
              .filter((it) => it.text);
          }
        } catch (error) {
          console.warn("Failed to load draft from server:", error);
        }
      }
    }

    // Source questions: group-specific if present; otherwise global template
    const groupQuestionsArr =
      groupQuestionList?.predictions?.[0]?.questions || [];
    const globalQuestionsArr = questions?.questions || [];

    const baseQuestions =
      Array.isArray(groupQuestionsArr) && groupQuestionsArr.length
        ? groupQuestionsArr
        : Array.isArray(globalQuestionsArr)
        ? globalQuestionsArr
        : [];

    // Draft extras that are NOT on server already
    const extrasQuestions = localItems
      .filter((it) => !serverNorms.has(norm(it.text)))
      .map((it) => ({ text: it.text, taskid: uuidv4() }));

    const htmlFields = `${buildInputsHtml(baseQuestions)}${buildInputsHtml(
      extrasQuestions
    )}`;

    const maxRows = getMaxRows(category);

    const commonSwalConfig = {
      html: `
        <div id="qa-scroll" style="max-height: 40vh; overflow-y: auto; font-size: 12px;">
          ${htmlFields}
        </div>
        <div id="qa-toolbar" style="display:flex;justify-content:space-between;align-items:center;margin-top:8px;">
          <button type="button" id="btn-add-question" class="btn btn-sm btn-outline-primary">Add question</button>
        </div>`,
      showCloseButton: false,
      showCancelButton: true,
      showConfirmButton: false,
      showDenyButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#808080",
      denyButtonColor: "#00CC00",
      denyButtonText: "Publish",
      confirmButtonText: "Save Draft",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
      customClass: {
        htmlContainer: "swal2-html-container",
        popup: "swal2-popup sw-responsive",
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-secondary",
        denyButton: "btn btn-success",
        width: "80%",
      },
      didOpen: () => {
        const wrap = Swal.getHtmlContainer();
        const container = wrap.querySelector("#qa-scroll");

        const yearForLS2 = category === "Goals" ? useYear : displayYear;
        const currentGroupName2 = localStorage.getItem("user_initial_Group");

        const saveNow = async () => {
          if (!currentGroupName2) return;

          const inputs = container.querySelectorAll(".swal2-input");
          const items = serializeInputsExtras(inputs, serverNorms);

          try {
            await fetch(
              `${process.env.REACT_APP_PREDICTIONS_API}/api/save-draft-questions`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                  category,
                  year: yearForLS2,
                  groupName: currentGroupName2,
                  questions: items,
                }),
              }
            );
          } catch (error) {
            console.warn("Failed to save draft to server:", error);
          }
        };

        const saveNowDebounced = ((fn, ms = 250) => {
          let t;
          return (...a) => {
            clearTimeout(t);
            t = setTimeout(() => fn(...a), ms);
          };
        })(saveNow);

        // wrap inputs into rows + add remove buttons
        const allInputs = container.querySelectorAll(".swal2-input");
        Array.from(allInputs).forEach((inp) => {
          if (inp.closest(".qa-row")) return;

          const row = document.createElement("div");
          row.className = "qa-row";
          row.style.cssText =
            "display:flex;align-items:center;gap:8px;padding:2px 0;";

          inp.style.margin = "0";
          const parent = inp.parentNode;
          parent.insertBefore(row, inp);
          row.appendChild(inp);

          const btn = document.createElement("button");
          btn.type = "button";
          btn.className = "btn btn-sm btn-outline-secondary btn-remove";
          btn.setAttribute("aria-label", "Remove");
          btn.textContent = "×";
          row.appendChild(btn);
        });

        container.addEventListener("input", (e) => {
          if (e.target && e.target.classList.contains("swal2-input"))
            saveNowDebounced();
        });

        container.addEventListener("click", (e) => {
          const rm = e.target.closest(".btn-remove");
          if (!rm) return;
          const row = rm.closest(".qa-row");
          if (row) {
            row.remove();
            saveNow();
          }
        });

        wrap
          .querySelector("#btn-add-question")
          ?.addEventListener("click", () => {
            const rowsNow = container.querySelectorAll(".qa-row").length;
            if (rowsNow >= maxRows) return;

            const row = document.createElement("div");
            row.className = "qa-row";
            row.style.cssText =
              "display:flex;align-items:center;gap:8px;padding:2px 0;";

            const input = document.createElement("input");
            input.type = "text";
            input.className = "swal2-input";
            input.maxLength = 150;
            input.style.cssText = "width:100%;font-size:12px;margin:0;";
            input.placeholder = "new entry";
            input.value = "";
            input.id = uuidv4();
            input.name = "";

            const btn = document.createElement("button");
            btn.type = "button";
            btn.className = "btn btn-sm btn-outline-secondary btn-remove";
            btn.setAttribute("aria-label", "Remove");
            btn.textContent = "×";

            row.appendChild(input);
            row.appendChild(btn);
            container.appendChild(row);

            container.scrollTop = container.scrollHeight;
            setTimeout(saveNow, 0);
          });
      },
    };

    if (storedRole === "globalAdmin") {
      Swal.fire({
        title: `${category}`,
        ...commonSwalConfig,
        preConfirm: async () => {
          Swal.fire("", "(coming soon).", "success");
        },
        preDeny: async () => {
          const inputElements = document.querySelectorAll(".swal2-input");

          const arr = [...inputElements]
            .map((inputElement) => {
              const v = (inputElement.value || "").trim();
              if (!v || v === "(new entry)") return null;

              return {
                text: v,
                taskid: inputElement.name === "" ? uuidv4() : inputElement.name,
              };
            })
            .filter(Boolean);

          const memberId = storedDetails?.data?.id;
          const encodedMemberId = encodeURIComponent(memberId || "");

          await fetch(
            `${process.env.REACT_APP_PREDICTIONS_API}/api/admin-update-yealy-templates/${displayYear}/${encodedMemberId}`,
            {
              method: "PATCH",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({
                questions: arr,
                mode: "published",
                category,
              }),
            }
          );

          Swal.fire("Thanks!", `${category} Template Updated`, "success").then(
            (result) => {
              if (result.isConfirmed) {
                const currentGroupName =
                  localStorage.getItem("user_initial_Group");
                if (currentGroupName) {
                  const yearForLS =
                    category === "Goals" ? useYear : displayYear;

                  fetch(
                    `${process.env.REACT_APP_PREDICTIONS_API}/api/save-draft-questions`,
                    {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                      },
                      body: JSON.stringify({
                        category,
                        year: yearForLS,
                        groupName: currentGroupName,
                        questions: [],
                      }),
                    }
                  ).catch(console.error);
                }
                window.location.reload();
              }
            }
          );
        },
      });

      return;
    }

    Swal.fire({
      title: `${displayYear} ${category}`,
      ...commonSwalConfig,
      preConfirm: async () => {
        const inputElements = document.querySelectorAll(".swal2-input");

        const arr = [...inputElements]
          .map((inputElement) => {
            const v = (inputElement.value || "").trim();
            if (!v || v === "(new entry)") return null;

            const name = inputElement.name;
            const taskid = name === "" || name === "0" ? uuidv4() : name;

            return { text: v, taskid };
          })
          .filter(Boolean);

        const memberId = storedDetails?.data?.id;
        const encodedMemberId = encodeURIComponent(memberId || "");
        const currentGroupName = localStorage.getItem("user_initial_Group");

        if (category === "Predictions") {
          await fetch(
            `${process.env.REACT_APP_PREDICTIONS_API}/api/update-yealy-predictions/${displayYear}/${encodedMemberId}`,
            {
              method: "PATCH",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({
                questions: arr,
                mode: "draft",
                groupName: currentGroupName,
              }),
            }
          );
        } else if (category === "Goals") {
          await fetch(
            `${process.env.REACT_APP_PREDICTIONS_API}/api/update-yealy-goals/${useYear}/${encodedMemberId}`,
            {
              method: "PATCH",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({
                questions: arr,
                mode: "draft",
              }),
            }
          );
        } else if (category === "Bucketlist") {
          await fetch(
            `${process.env.REACT_APP_PREDICTIONS_API}/api/update-yealy-bucketlist/${displayYear}/${encodedMemberId}`,
            {
              method: "PATCH",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({
                questions: arr,
                mode: "draft",
              }),
            }
          );
        }

        Swal.fire("Thanks!", `Group ${category} Updated`, "success").then(
          (result) => {
            if (result.isConfirmed) {
              const currentGroupName2 =
                localStorage.getItem("user_initial_Group");
              if (currentGroupName2) {
                const yearForLS = category === "Goals" ? useYear : displayYear;

                fetch(
                  `${process.env.REACT_APP_PREDICTIONS_API}/api/save-draft-questions`,
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                      category,
                      year: yearForLS,
                      groupName: currentGroupName2,
                      questions: [],
                    }),
                  }
                ).catch(console.error);
              }
              window.location.reload();
            }
          }
        );
      },
      preDeny: async () => {
        const inputElements = document.querySelectorAll(".swal2-input");

        const arr = [...inputElements]
          .map((inputElement) => {
            const v = (inputElement.value || "").trim();
            if (!v || v === "(new entry)") return null;

            const name = inputElement.name;
            const taskid = name === "" || name === "0" ? uuidv4() : name;

            return { text: v, taskid };
          })
          .filter(Boolean);

        const memberId = storedDetails?.data?.id;
        const encodedMemberId = encodeURIComponent(memberId || "");
        const currentGroupName = localStorage.getItem("user_initial_Group");

        if (category === "Predictions") {
          await fetch(
            `${process.env.REACT_APP_PREDICTIONS_API}/api/update-yealy-predictions/${displayYear}/${encodedMemberId}`,
            {
              method: "PATCH",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({
                questions: arr,
                mode: "published",
                groupName: currentGroupName,
              }),
            }
          );
        } else if (category === "Goals") {
          await fetch(
            `${process.env.REACT_APP_PREDICTIONS_API}/api/update-yealy-goals/${useYear}/${encodedMemberId}`,
            {
              method: "PATCH",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({
                questions: arr,
                mode: "published",
              }),
            }
          );
        } else if (category === "Bucketlist") {
          await fetch(
            `${process.env.REACT_APP_PREDICTIONS_API}/api/update-yealy-bucketlist/${displayYear}/${encodedMemberId}`,
            {
              method: "PATCH",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({
                questions: arr,
                mode: "published",
              }),
            }
          );
        }

        Swal.fire("Thanks!", `Group ${category} Updated`, "success").then(
          (result) => {
            if (result.isConfirmed) {
              const currentGroupName2 =
                localStorage.getItem("user_initial_Group");
              if (currentGroupName2) {
                const yearForLS = category === "Goals" ? useYear : displayYear;

                fetch(
                  `${process.env.REACT_APP_PREDICTIONS_API}/api/save-draft-questions`,
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                      category,
                      year: yearForLS,
                      groupName: currentGroupName2,
                      questions: [],
                    }),
                  }
                ).catch(console.error);
              }
              window.location.reload();
            }
          }
        );
      },
    });
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-6">
            <form className="profile-form">
              <div className="card-body">
                <h6>
                  &nbsp;{storedRole === "globalAdmin" ? "Global" : "Groups"}{" "}
                  Template
                </h6>

                {type === "predictions" ? (
                  <div className="row">
                    {availablePredictionYears.map((year) => {
                      const template = predictionsByYear[year]?.[0];
                      const hasTemplate =
                        template !== undefined && template !== null;

                      return (
                        <button
                          key={year}
                          type="button"
                          className="btn btn-primary dz-xs-flex m-r5"
                          style={{
                            backgroundColor: "#6B8DEF",
                            width: "90px",
                            height: "84px",
                            margin: "2px",
                            padding: "0px",
                          }}
                          disabled={!hasTemplate}
                          onClick={() =>
                            handleButtonClick(
                              "Predictions",
                              template || { year: String(year), questions: [] },
                              year
                            )
                          }
                        >
                          {year} Predictions
                        </button>
                      );
                    })}
                  </div>
                ) : (
                  <div className="row">
                    {(storedRole === "groupAdmin" ||
                      storedRoleEnhanced === "groupAdmin" ||
                      storedRole === "globalAdmin") && (
                      <button
                        type="button"
                        variant="primary"
                        className="btn btn-primary dz-xs-flex m-r5"
                        style={{
                          backgroundColor: "#808080",
                          width: "90px",
                          height: "84px",
                          margin: "2px",
                          padding: "0px",
                        }}
                        onClick={() =>
                          handleButtonClick("Goals", pastGoals, pastYear)
                        }
                      >
                        {pastYear} Goals
                      </button>
                    )}
                    &nbsp;
                    <button
                      type="button"
                      variant="primary"
                      className="btn btn-primary dz-xs-flex m-r5"
                      style={{
                        backgroundColor: "#6B8DEF",
                        width: "90px",
                        height: "84px",
                        margin: "2px",
                        padding: "0px",
                      }}
                      onClick={() =>
                        handleButtonClick("Goals", currentGoals, currentYear)
                      }
                    >
                      {currentYear} Goals
                    </button>
                    &nbsp;
                    {(storedRole === "groupAdmin" ||
                      storedRoleEnhanced === "groupAdmin" ||
                      storedRole === "globalAdmin") && (
                      <button
                        type="button"
                        variant="primary"
                        className="btn btn-primary dz-xs-flex m-r5"
                        style={{
                          backgroundColor: "#808080",
                          width: "90px",
                          height: "84px",
                          margin: "2px",
                          padding: "0px",
                        }}
                        onClick={() =>
                          handleButtonClick("Goals", nextGoals, nextYear)
                        }
                      >
                        {nextYear} Goals
                      </button>
                    )}
                    &nbsp;
                  </div>
                )}
              </div>
              &nbsp;
            </form>
            <div></div>
          </div>

          <div className="col-md-6">
            &nbsp;
            {type === "predictions" ? (
              <div className="card profile-card card-bx p-2">
                <div>
                  <h5>Global Template</h5>
                </div>

                {availablePredictionYears.map((year) => {
                  const template = predictionsByYear[year]?.[0];
                  const questions = Array.isArray(template?.questions)
                    ? template.questions
                    : [];

                  return (
                    <details key={year}>
                      <summary className="fw-bold text-dark fs-6">
                        {year} Predictions{" "}
                        {questions.length > 0 &&
                          `(${questions.length} questions)`}
                      </summary>

                      <HistoryPredictionsView
                        year={year}
                        predictions={{
                          predictions: questions,
                        }}
                      />
                    </details>
                  );
                })}
              </div>
            ) : (
              <div className="card profile-card card-bx p-2">
                <div>
                  <h5>Global Template</h5>
                </div>

                <details>
                  <summary className="fw-bold text-dark fs-6">
                    {pastYear} Goals
                  </summary>
                  <HistoryPredictionsView
                    year={pastYear}
                    predictions={pastGoals}
                  />
                </details>

                <details>
                  <summary className="fw-bold text-dark fs-6">
                    {currentYear} Goals
                  </summary>
                  <HistoryPredictionsView
                    year={currentYear}
                    predictions={currentGoals}
                  />
                </details>

                <details>
                  <summary className="fw-bold text-dark fs-6">
                    {nextYear} Goals
                  </summary>
                  <HistoryPredictionsView
                    year={nextYear}
                    predictions={pastGoals}
                  />
                </details>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default QuestionsTemplate;
